import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { BillSchema } from '../base/index.js';
export const InvokeCreateBillRequestSchema = z.object({
    bill: BillSchema.pick({ total: true, vendor: true }),
    entityId: CornSchema,
    additional: z.record(z.string(), z.unknown()).optional(),
    requestActor: z.string(),
});
export const InvokeCreateBillResponseSchema = z.object({ bill: BillSchema });
